<div class="container">
  @if (isLoading) {
  <aw-spinner [fullScreen]="true"></aw-spinner>
  }
  <aw-bread-crumb [breadcrumbs]="breadcrumbs()" ariaLabel="Add Third-Party Employee"></aw-bread-crumb>

  <aw-dialog
    [visible]="openEmployeeInfoDialog"
    [dialogOptions]="dialogOptions"
    (primaryAction)="dialogCloseHandler()"
    ariaLabel="Third-Party Employee Created"
  >
  </aw-dialog>

  <aw-toast></aw-toast>
  <app-unsaved-changes-dialog></app-unsaved-changes-dialog>

  <aw-divider
    [inset]="false"
    [middleInset]="false"
    [title]="'New Third-Party Employee'"
    [altColor]="false"
  >
  </aw-divider>

  <div class="field-row">
    <!-- Employee Name Field -->
    <app-aw-text-form
      class="field-half"
      [disable]="false"
      [readOnly]="false"
      [required]="true"
      title="Name"
      (textEntry)="onEmployeeNameSelected($event)"
    ></app-aw-text-form>

    <!-- Employee Email Address Field -->
    <app-aw-text-form
      class="field-half"
      [disable]="false"
      [readOnly]="false"
      [required]="true"
      title="Email"
      (textEntry)="onEmployeeEmailSelected($event)"
    ></app-aw-text-form>

    <!-- Organization ID Field -->
    <app-aw-text-form
      class="field-half"
      [disable]="false"
      [readOnly]="false"
      [required]="true"
      title="Integration ID"
      (textEntry)="onOrganizationIDSelected($event)"
    ></app-aw-text-form>
  </div>
</div>
<div class="footer-container">
  <aw-action-bar [actionsRight]="actionsRight()"> </aw-action-bar>
</div>
